import { render, staticRenderFns } from "./Articlebox.vue?vue&type=template&id=0b58a5c9&scoped=true&"
import script from "./Articlebox.vue?vue&type=script&lang=js&"
export * from "./Articlebox.vue?vue&type=script&lang=js&"
import style0 from "./Articlebox.vue?vue&type=style&index=0&id=0b58a5c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b58a5c9",
  null
  
)

export default component.exports